import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHardHat } from "@fortawesome/free-solid-svg-icons";

const Shop = () => {
  return (
    <div
      className="flex justify-center items-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + "/shop.jpg"})`,
      }}
    >
      <div className="text-center p-6 md:p-8 bg-black bg-opacity-70 rounded-lg md:rounded-xl shadow-lg transform transition-all hover:scale-105 hover:shadow-2xl w-full max-w-lg md:max-w-2xl">
        <h1 className="text-3xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300 mb-4 md:mb-6 animate-pulse">
          Shop - Coming Soon
        </h1>
        <p className="text-lg md:text-2xl text-gray-400 mb-4 md:mb-6 animate-fadeIn">
          This page is under construction. Stay tuned for updates!
        </p>
        <div className="text-5xl md:text-6xl text-yellow-500 mb-4 md:mb-6 animate-bounceSlow">
          <FontAwesomeIcon icon={faHardHat} />
        </div>
        <p className="text-base md:text-xl text-gray-400 mt-2 md:mt-4 animate-slideInUp">
          Exciting new things are on the way!
        </p>
      </div>
    </div>
  );
};

export default Shop;
